// extracted by mini-css-extract-plugin
module.exports = {"button":"law_firm_actions-module__button--16bxf"};